import { AfterViewInit, ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RouterOutlet } from '@angular/router';

import { APP_SPINNER, APP_TOAST } from '@efficiently/client-util-constants';
import { SnackbarService } from '@efficiently/client-widget-snackbar';

import { CDK_OVERLAY_HOLDER } from '@ds/core/constants';
import { SidenavWrapperComponent } from '@ds/shared/modules';
import { ToastsService } from '@ds/shared/modules/toasts/toasts.service';

@Component({
	// tslint:disable-next-line: component-selector
	selector: 'app-root',
	templateUrl: './app.component.html',
	styleUrl: './app.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [RouterOutlet, SidenavWrapperComponent],
})
export class AppComponent implements OnInit, AfterViewInit {
	private readonly titleService = inject(Title);
	// TODO EFF-18860
	// public readonly intercom: Intercom,
	// public readonly appConfigService: AppConfigService,
	private readonly snackbarService = inject(SnackbarService);
	private readonly toastsService = inject(ToastsService);

	protected readonly overlay = CDK_OVERLAY_HOLDER;
	protected readonly appSpinner = APP_SPINNER;
	protected readonly appToast = APP_TOAST;

	public ngOnInit(): void {
		this.titleService.setTitle('Design Efficiently');
		this.snackbarService.init();
	}

	public ngAfterViewInit(): void {
		this.toastsService.setToastOverlay();
	}
}
